export default __webpack_public_path__ + "static/media/OriginalGuideDoc2.666381e9.pdf";